import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogHeader,
} from "@/components/ui/dialog";
import { useUser } from "@/context/user-context";
import { useEffect } from "react";
import { Mail, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { CopyButton } from "./ui/copy-button";

const MIN_REFERRAL_DAYS = 15;
const MAX_REFERRAL_DAYS = 20;

export const ReferAFriendDialog = ({
  setIsOpen,
  isOpen,
}: {
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
}) => {
  const { user } = useUser();
  const createdAt = user?.createdAt;
  const isReccuring = createdAt % 90 === 0;
  const is15to20Days =
    createdAt > MIN_REFERRAL_DAYS && createdAt < MAX_REFERRAL_DAYS;

  const referralEmail = "referrals@promptlayer.com";
  const referralLink = "https://promptlayer.com/referral";

  useEffect(() => {
    if (is15to20Days && !localStorage.getItem("referral-dialog-shown")) {
      localStorage.setItem("referral-dialog-shown", "true");
      setIsOpen(true);
    } else if (isReccuring) {
      setIsOpen(true);
    }
  }, [is15to20Days, isReccuring, setIsOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-md p-6">
        <DialogHeader className="mb-4">
          <DialogTitle className="text-center text-lg font-medium">
            Enjoying PromptLayer? Refer a friend!
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center space-y-1 py-2 text-center">
          <div className="flex items-baseline justify-center">
            <span>
              <span className="ml-1 text-gray-500"> Earn</span>{" "}
              <span className="font-bold"> 10%</span>
            </span>
            <span className="ml-1 text-gray-500">
              of annual contract amount,
            </span>
          </div>
          <div className="font-bold text-gray-900">
            Up to $3,000!{" "}
            <span className="ml-1 font-normal text-gray-500">
              {" "}
              per referral 🍰
            </span>
          </div>
        </div>
        <div className="my-4 border-t border-gray-100"></div>
        <div className="space-y-4">
          <div className="rounded-md px-1 py-2">
            <div className="flex items-center gap-2">
              <Mail className="h-5 w-5 text-gray-600" />
              <h3 className="font-semibold text-gray-800">
                Best Option: Email Introduction
              </h3>
            </div>
            <p className="ml-7 mt-1 text-sm text-gray-500">
              Create an email thread with your friend and{" "}
              <span className="inline-flex items-center font-medium text-gray-700 hover:text-gray-900">
                {referralEmail}
              </span>
              .
              <br /> Include a quick sentence about how you think they would
              benefit from PromptLayer.
            </p>
          </div>
          <div className="rounded-md bg-gray-50 px-3 py-2">
            <div className="flex items-center justify-between">
              <div className="truncate text-xs text-gray-500">
                Email: {referralEmail}
              </div>
              <div className="ml-2">
                <CopyButton text={referralEmail} iconSize="h-4 w-4" />
              </div>
            </div>
          </div>
          <div className="rounded-md px-1 py-2">
            <div className="flex items-center gap-2">
              <FileText className="h-5 w-5 text-gray-500" />
              <h3 className="font-medium text-gray-600">
                Good Option: Submit{" "}
                <Link
                  to={referralLink}
                  className="font-medium text-gray-500 underline hover:text-gray-700"
                  target="_blank"
                >
                  Referral Form
                </Link>
              </h3>
            </div>
          </div>
        </div>
        <div className="rounded-md bg-gray-50 px-3 py-2">
          <div className="flex items-center justify-between">
            <div className="truncate text-xs text-gray-500">
              Link: {referralLink}
            </div>
            <div className="ml-2">
              <CopyButton text={referralLink} iconSize="h-4 w-4" />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
